// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review-page {
  max-width: 500px;
  margin: 0 auto;
  text-align: center;
}

.review-progress {
  background: var(--primary);
  color: white;
  padding: 8px 20px;
  border-radius: 20px;
  display: inline-block;
  font-weight: 700;
  margin-bottom: 24px;
}

.review-card {
  background: white;
  border-radius: 24px;
  padding: 40px;
  box-shadow: var(--shadow);
}

.review-english {
  font-size: 40px;
  font-weight: 800;
  color: var(--primary);
  margin-bottom: 20px;
}

.speak-btn-large {
  background: var(--accent);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 24px;
  transition: transform 0.2s;
}

.speak-btn-large:hover {
  transform: scale(1.05);
}

.show-answer-btn {
  width: 100%;
}

.review-polish {
  font-size: 32px;
  color: var(--text);
  margin: 24px 0;
  padding: 20px;
  background: var(--background);
  border-radius: 12px;
}

.review-question {
  color: var(--text-light);
  margin-bottom: 16px;
}

.answer-buttons {
  display: flex;
  gap: 16px;
}

.answer-buttons .btn {
  flex: 1 1;
  padding: 16px;
  font-size: 18px;
}

.btn-danger {
  background: var(--danger);
  color: white;
}

.btn-success {
  background: var(--success);
  color: white;
}

/* No review state */
.no-review {
  text-align: center;
  padding: 60px 20px;
}

.no-review-icon {
  font-size: 80px;
  margin-bottom: 16px;
}

.no-review h2 {
  margin-bottom: 8px;
}

.no-review p {
  color: var(--text-light);
  margin-bottom: 24px;
}

/* Complete state */
.review-complete {
  text-align: center;
  padding: 60px 20px;
}

.review-complete .complete-icon {
  font-size: 80px;
  margin-bottom: 16px;
}

.review-complete h1 {
  margin-bottom: 24px;
}

.review-complete .points-earned {
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: #333;
  padding: 16px 32px;
  border-radius: 20px;
  font-size: 28px;
  font-weight: 800;
  display: inline-block;
  margin-bottom: 32px;
}

`, "",{"version":3,"sources":["webpack://./src/pages/Review.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":[".review-page {\n  max-width: 500px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.review-progress {\n  background: var(--primary);\n  color: white;\n  padding: 8px 20px;\n  border-radius: 20px;\n  display: inline-block;\n  font-weight: 700;\n  margin-bottom: 24px;\n}\n\n.review-card {\n  background: white;\n  border-radius: 24px;\n  padding: 40px;\n  box-shadow: var(--shadow);\n}\n\n.review-english {\n  font-size: 40px;\n  font-weight: 800;\n  color: var(--primary);\n  margin-bottom: 20px;\n}\n\n.speak-btn-large {\n  background: var(--accent);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-size: 18px;\n  font-weight: 600;\n  cursor: pointer;\n  margin-bottom: 24px;\n  transition: transform 0.2s;\n}\n\n.speak-btn-large:hover {\n  transform: scale(1.05);\n}\n\n.show-answer-btn {\n  width: 100%;\n}\n\n.review-polish {\n  font-size: 32px;\n  color: var(--text);\n  margin: 24px 0;\n  padding: 20px;\n  background: var(--background);\n  border-radius: 12px;\n}\n\n.review-question {\n  color: var(--text-light);\n  margin-bottom: 16px;\n}\n\n.answer-buttons {\n  display: flex;\n  gap: 16px;\n}\n\n.answer-buttons .btn {\n  flex: 1;\n  padding: 16px;\n  font-size: 18px;\n}\n\n.btn-danger {\n  background: var(--danger);\n  color: white;\n}\n\n.btn-success {\n  background: var(--success);\n  color: white;\n}\n\n/* No review state */\n.no-review {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.no-review-icon {\n  font-size: 80px;\n  margin-bottom: 16px;\n}\n\n.no-review h2 {\n  margin-bottom: 8px;\n}\n\n.no-review p {\n  color: var(--text-light);\n  margin-bottom: 24px;\n}\n\n/* Complete state */\n.review-complete {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.review-complete .complete-icon {\n  font-size: 80px;\n  margin-bottom: 16px;\n}\n\n.review-complete h1 {\n  margin-bottom: 24px;\n}\n\n.review-complete .points-earned {\n  background: linear-gradient(135deg, #FFD700, #FFA500);\n  color: #333;\n  padding: 16px 32px;\n  border-radius: 20px;\n  font-size: 28px;\n  font-weight: 800;\n  display: inline-block;\n  margin-bottom: 32px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
